import React from "react"
import Grid from "../../grid"
import { H2, P } from "../../typography"

const RpInterviewSummary = () => (
  <Grid gap="4px">
    <H2 variant="primary" profile>
      Interview Summary
    </H2>
    <P
      variant="content"
      marginless
      profileData
    >{`This participant had frequent communication with a member of Camp Leaders' staff and has been given guidance on the returnee application process.`}</P>
    <P
      variant="content"
      marginless
      profileData
    >{`Having been interviewed and successfully completed a past season at camp the participant has already fulfilled all the criteria required to be an excellent staff member at camp.`}</P>
    <P
      variant="content"
      marginless
      profileData
    >{`Reference, camp contact, police check and full documentation are provided. Please contact Camp Leaders directly for these if necessary.`}</P>
  </Grid>
)

export default RpInterviewSummary
